export const stroke = {
  none: "0",
  xs: "1px",
  sm: "1.5px",
  md: "2px",
  lg: "2.5px",
  xl: "3px"
} as const;

export type Stroke = typeof stroke;
